import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-search-result-header',
  templateUrl: './search-result-header.component.html',
  styleUrls: ['./search-result-header.component.css']
})
export class SearchResultHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() itemCount: number;

  constructor() { }

  ngOnInit() {
  }

}
